import {
  Avatar,
  Container,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Paper,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { db } from "../../config/Firebase";

const Leaderboard = () => {
  const [scores, setScores] = useState([]);
  useEffect(() => {
    db.collection("users")
      .orderBy("points", "desc")
      .get()
      .then((ds) => {
        const scores = ds.docs.map((doc) => {
          const { points, dp, username } = doc.data();
          return { points, dp, username };
        });
        setScores(scores);
      });
  }, []);
  return (
    <Container>
      <Typography variant="h2">Leaderboard</Typography>
      <Paper>
        <List>
          {scores.map(({ points, dp, username }) => {
            return (
              <ListItem divider>
                <ListItemAvatar>
                  <Avatar src={dp} alt={username} />
                </ListItemAvatar>
                <ListItemText primary={username} />
                <ListItemSecondaryAction>{points}Pts.</ListItemSecondaryAction>
              </ListItem>
            );
          })}
        </List>
      </Paper>
    </Container>
  );
};

export default Leaderboard;
